import { createAppAsyncThunk } from '@/redux/create-app-thunk';

export const getLastUserOrder = createAppAsyncThunk(
  'checkout/getLastUserOrder',
  async (_, { rejectWithValue, extra: { checkoutService } }) => {
    try {
      return await checkoutService.getUserLastOrder();
    } catch (error) {
      return rejectWithValue({});
    }
  }
);
